import { useAccountState } from 'contexts/account/account-context';
import { SnackbarActionTypes, useSnackbarDispatch } from 'contexts/snackbar/SnackbarContext';
import { usePost } from 'hooks/use-post';
import { useIntl } from 'react-intl';
import { useQueryClient } from '@tanstack/react-query';
import { putScenario } from '../api/bluviu-nutrition';
import { Scenario } from '../types/scenario.type';
import { UpdateScenarioRequest } from '../types/update-scenario-input.type';

/**
 * TODO: Placeholder for updating scenario, similar to Create Calibration
 * A hook for updating a scenario. It attempts to obfuscate boilerplate code out of a component and only expose what is necessary.
 */
export const useUpdateScenario = () => {
  const queryClient = useQueryClient();
  const snackbarDispatch = useSnackbarDispatch();
  const intl = useIntl();
  const {
    account: { company },
  } = useAccountState();

  const updateScenario = usePost<Scenario, { scenarioId: string; request: UpdateScenarioRequest }>(
    (request) => putScenario(company!.companyId, request.scenarioId, request.request),
    (response) => {
    //   queryClient.setQueryData(['getScenario', response.globalCompanyId, response.id], response);
      snackbarDispatch({
        type: SnackbarActionTypes.SUCCESS_SNACKBAR,
        payload: { msg: intl.formatMessage({ id: 'snackbar.success.default' }) },
      });
    },
    (error) => {
      snackbarDispatch({
        type: SnackbarActionTypes.ERROR_SNACKBAR,
        payload: { msg: intl.formatMessage({ id: 'snackbar.errors.default' }), error: error },
      });
    }
  );

  return { updateScenario };
};
